import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'app-electricity-forecast-eoy',
  standalone: true,
  imports: [CommonModule, TranslocoPipe, RouterLink],
  templateUrl: './electricity-forecast-eoy.component.html',
  styleUrl: './electricity-forecast-eoy.component.css'
})
export class ElectricityForecastEoyComponent implements OnInit, OnChanges {
 
  // Dummy data
  @Input() showDummyData: boolean = false;
  dummyconsumptionValue: number = 6.4218;
  dummycostValue: number = 461.287;
  dummybudgetValue: number = 845.654;
  dummybudgetDifference: number = 8.284;

  @Input() consumptionValue: number = 6.4218;
  @Input() costValue: number = 461.287;
  @Input() budgetValue: number = 845.654;
  @Input() budgetDifference: number = 8.284;
  
  @Input() showUpgrade: boolean = false;

  ngOnChanges(changes: SimpleChanges): void {
    this.updateData();
  }

  ngOnInit(): void {
    this.updateData();
  }

  updateData(): void
  {
    if(this.showDummyData)
    {
      this.consumptionValue = this.dummyconsumptionValue;
      this.costValue = this.dummycostValue;
      this.budgetValue = this.dummybudgetValue;
      this.budgetDifference = this.dummybudgetDifference;
    }
  }
}
